import { useEffect, useRef, useState } from 'react';

export default function useSwipeDetection() {
	const [isSwipe, setIsSwipe] = useState(false);

	const startXRef = useRef(null);
	const timeoutRef = useRef(null);

	useEffect(() => {
		// const touchStart = e => {
		// 	console.log('touchStart', e);

		// 	startXRef.current = e.touches[0].clientX;

		// 	clearTimeout(timeoutRef.current);
		// 	timeoutRef.current = null;
		// };

		const touchMove = e => {
			setIsSwipe(true);
			clearTimeout(timeoutRef.current);

			timeoutRef.current = setTimeout(() => {
				setIsSwipe(false);
				timeoutRef.current = null;
			}, 350);
		};

		// const touchEnd = e => {
		// 	console.log('touchEnd 000 ', e.changedTouches);

		// 	if (startXRef.current === null) return;

		// 	console.log('touchEnd 111 ', e.changedTouches);

		// 	const deltaX = e.changedTouches[0].clientX - startXRef.current;

		// 	if (Math.abs(deltaX) > 50) {
		// 		setIsSwipe(true);
		// 	}

		// timeoutRef.current = setTimeout(() => {
		// 	setIsSwipe(false);
		// }, 350);

		// 	startXRef.current = null;
		// };

		// window.addEventListener('touchstart', touchStart, { passive: true });
		window.addEventListener('touchmove', touchMove, { passive: true });
		// window.addEventListener('touchend', touchEnd, { passive: true });
		// window.addEventListener('touchcancel', touchEnd, { passive: true });

		return () => {
			// window.removeEventListener('touchstart', touchStart, { passive: true });
			window.removeEventListener('touchmove', touchMove, { passive: true });
			// window.removeEventListener('touchend', touchEnd, { passive: true });
			// window.removeEventListener('touchcancel', touchEnd, { passive: true });
		};
	}, []);

	return isSwipe;
}
